/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {TableHeaderEntryModel} from '../../../../shared/table/models/table-header-entry.model';
import {AlertsColumnEnum} from '../models/alerts-column.enum';
import {
    dateFullFormatPipe,
    dateSimpleFormatUTCPipe,
    statusPipe,
    userPipe
} from '../../../../api/ms-settings/shared/pipes/alerts-config-table-data-pipes';

const alertsConfigMainPageHeaderConfiguration: {
    alertName: TableHeaderEntryModel<AlertsColumnEnum>;
    alertContent: TableHeaderEntryModel<AlertsColumnEnum>;
    startsOn: TableHeaderEntryModel<AlertsColumnEnum>;
    endsOn: TableHeaderEntryModel<AlertsColumnEnum>;
    createdBy: TableHeaderEntryModel<AlertsColumnEnum>;
    createdOn: TableHeaderEntryModel<AlertsColumnEnum>;
    updatedBy: TableHeaderEntryModel<AlertsColumnEnum>;
    updatedOn: TableHeaderEntryModel<AlertsColumnEnum>;
    status: TableHeaderEntryModel<AlertsColumnEnum>;
    smallTableWidth: number;
    excludeColumnsOnResize: AlertsColumnEnum[];
} = {
    alertName: {
        code: AlertsColumnEnum.NAME,
        name: 'Alert name',
        sortable: true,
        widthWeight: 8
    },
    alertContent: {
        code: AlertsColumnEnum.DESCRIPTION,
        name: 'Alert content',
        sortable: true,
        widthWeight: 14
    },
    startsOn: {
        code: AlertsColumnEnum.STARTS_ON,
        name: 'Starts on',
        sortable: true,
        widthWeight: 5,
        dataPipe: dateSimpleFormatUTCPipe
    },
    endsOn: {
        code: AlertsColumnEnum.ENDS_ON,
        name: 'Ends on',
        sortable: true,
        widthWeight: 4,
        dataPipe: dateSimpleFormatUTCPipe
    },
    createdBy: {
        code: AlertsColumnEnum.CREATED_BY,
        name: 'Created by',
        sortable: true,
        widthWeight: 7,
        dataPipe: userPipe
    },
    createdOn: {
        code: AlertsColumnEnum.CREATED_ON,
        name: 'Created on',
        sortable: true,
        widthWeight: 7,
        dataPipe: dateFullFormatPipe
    },
    updatedBy: {
        code: AlertsColumnEnum.UPDATED_BY,
        name: 'Updated by',
        sortable: true,
        widthWeight: 7,
        dataPipe: userPipe
    },
    updatedOn: {
        code: AlertsColumnEnum.UPDATED_ON,
        name: 'Updated on',
        sortable: true,
        widthWeight: 7,
        dataPipe: dateFullFormatPipe
    },
    status: {
        code: AlertsColumnEnum.ACTIVE,
        name: 'Status',
        sortable: true,
        widthWeight: 6,
        dataPipe: statusPipe,
        hasDot: true
    },
    smallTableWidth: 1000,
    excludeColumnsOnResize: [AlertsColumnEnum.DESCRIPTION, AlertsColumnEnum.STARTS_ON, AlertsColumnEnum.ENDS_ON]
};

export default alertsConfigMainPageHeaderConfiguration;
